import { View, ViewModel } from "binder";
import { SearchableSelectorBaseViewModel } from "./searchableSelectorBase/searchableSelectorBase-viewModel";
import { SelectorBaseViewModel } from "./selectorBase/selectorBase-viewModel"

export class GenericSelector extends SelectorBaseViewModel<classType>{
    public dataLoaderFunction : (instanceCreator : ()=>classType)=>Promise<classType[]>;
    
    protected async loadData(): Promise<classType[]> {
        return await this.dataLoaderFunction(()=>new classType(this));
    }
}

export class GenericSearchableSelector extends SearchableSelectorBaseViewModel<classType> {
    public dataLoaderFunction : (id:string,searchText:string,instanceCreator : ()=>classType)=>Promise<classType[]>;
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    protected async loadData(searchedText: string): Promise<classType[]> {
        return await this.dataLoaderFunction(null,searchedText,()=>new classType(this));
    }
    protected async loadById(id: string): Promise<classType> {
        let result = await this.dataLoaderFunction(id,null,()=>new classType(this))
        if(result.length==0)
            return null;
        return result[0];
    }
}
export class classType extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set data(v: any) { this._data = v; } public get data(): any { return this._data;} private _data: any;
}